(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight + 40}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  document.addEventListener('DOMContentLoaded', () => {
    const events = ['mousemove', 'touchstart', 'keydown'];
    const removeInitialHide = () => {
      document
        .querySelectorAll('.mega-menu__content--initial')
        .forEach((el) => el.classList.remove('mega-menu__content--initial'));
      events.forEach((ev) => window.removeEventListener(ev, removeInitialHide));
    };
    events.forEach((ev) => window.addEventListener(ev, removeInitialHide, { once: true }));

    let dropdownList = document.querySelectorAll('.m-dropdown-menu');
    let menuClickItems = document.querySelectorAll('.js-menu-click');

    dropdownList.forEach((dropdown) => {
      dropdown.classList.remove('d-none');
      document.getElementById('hasMegaMenu')?.classList.add('nav-is-ready');
    });

    let megaMenuList = document.querySelectorAll('.mega-menu');

    if (megaMenuList.length > 0) {
      megaMenuList.forEach((megaMenu) => {
        megaMenu.addEventListener('mouseenter', function checkHover() {
          megaMenu.querySelectorAll('video').forEach((video) => {
            if (!video.playing) {
              video.play();
            }
          });
        });
      });
    }

    const initializeMenu = () => {
      const menuContainer = document.querySelector('.multi-level-menu__column--input');
      if (!menuContainer || menuClickItems.length === 0) return;

      const wrappers = document.querySelectorAll('.multi-level-menu__wrapper');
      let hoverTimeout;

      const updateMenuState = (value, activeItem) => {
        menuClickItems.forEach((el) => {
          const isActive = el === activeItem;
          el.classList.toggle('is-active', isActive);
          el.setAttribute('aria-expanded', isActive);
        });

        wrappers.forEach((wrapper) => {
          const shouldShow = wrapper.getAttribute('data-associated-menu') === value;
          wrapper.classList.toggle('is-visible', shouldShow);
          wrapper.classList.toggle('is-hidden', !shouldShow);

          if (shouldShow) {
            wrapper.setAttribute('tabindex', '0');
            wrapper.focus();
          }
        });
      };

      menuContainer.addEventListener('click', (event) => {
        const clickedItem = event.target.closest('[data-value]');

        if (!clickedItem || !Array.from(menuClickItems).includes(clickedItem)) return;

        event.preventDefault();
        const value = clickedItem.getAttribute('data-value');
        updateMenuState(value, clickedItem);
      });

      menuClickItems.forEach((item) => {
        item.addEventListener('mouseenter', () => {
          const value = item.getAttribute('data-value');

          hoverTimeout = setTimeout(() => {
            updateMenuState(value, item);
          }, 200);
        });

        item.addEventListener('mouseleave', () => {
          clearTimeout(hoverTimeout);
        });
      });
    };

    if (menuClickItems.length > 0) {
      initializeMenu();
    }

    // Mega Menu Accessibility (tab / Esc / hover)
    // Ensure dropdowns are visible once JS is active
    document.querySelectorAll('.m-dropdown-menu').forEach((dropdown) => dropdown.classList.remove('d-none'));
    document.getElementById('hasMegaMenu')?.classList.add('nav-is-ready');

    const triggers = document.querySelectorAll('.header__menu-li-js [aria-haspopup="true"]');
    if (!triggers.length) return;

    const focusable_selector = 'a, button, [tabindex]:not([tabindex="-1"])';
    const headerWrapper = document.querySelector('.header-wrapper');
    let headerHasFocus = false;

    function updateHeaderBackground() {
      const anyMenuOpen = Array.from(triggers).some((t) => t.getAttribute('aria-expanded') === 'true');
      const shouldBeDark = anyMenuOpen || headerHasFocus;
    }

    if (headerWrapper) {
      headerWrapper.addEventListener('focusin', () => {
        headerHasFocus = true;
        updateHeaderBackground();
      });
      headerWrapper.addEventListener('focusout', () => {
        setTimeout(() => {
          headerHasFocus = headerWrapper.contains(document.activeElement);
          updateHeaderBackground();
        }, 0);
      });
    }

    triggers.forEach((trigger) => {
      const menuId = trigger.getAttribute('aria-controls');
      const menu = document.getElementById(menuId);
      if (!menu) return;
      const li = trigger.closest('.header__menu-li-js');
      let suppressFocusOpen = false;

      function setFocusable(disabled) {
        menu.querySelectorAll(focusable_selector).forEach((el) => {
          if (disabled) {
            el.setAttribute('tabindex', '-1');
            el.setAttribute('data-tab-disabled', 'true');
          } else if (el.hasAttribute('data-tab-disabled')) {
            el.removeAttribute('tabindex');
            el.removeAttribute('data-tab-disabled');
          }
        });
      }

      function toggleMenu(open) {
        trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
        menu.setAttribute('aria-hidden', open ? 'false' : 'true');
        setFocusable(!open);
        updateHeaderBackground();
      }

      // Start closed
      toggleMenu(false);

      // Open on focus (Tab into the trigger)
      trigger.addEventListener('focus', () => {
        if (suppressFocusOpen) {
          suppressFocusOpen = false;
          return;
        }
        toggleMenu(true);
      });

      // Mouse hover
      li?.addEventListener('mouseenter', () => toggleMenu(true));
      li?.addEventListener('mouseleave', () => toggleMenu(false));

      const isEsc = (event) => event.key === 'Escape' || event.key === 'Esc' || event.keyCode === 27;

      // Esc anywhere inside this li
      li?.addEventListener('keydown', (event) => {
        if (!isEsc(event)) return;
        if (trigger.getAttribute('aria-expanded') !== 'true') return;
        event.preventDefault();
        event.stopPropagation();
        suppressFocusOpen = true;
        toggleMenu(false);
        trigger.focus();
      });

      // Close when focus leaves the li
      li?.addEventListener('focusout', () => {
        setTimeout(() => {
          const active = document.activeElement;
          if (!li.contains(active)) {
            suppressFocusOpen = false;
            toggleMenu(false);
          }
        }, 0);
      });
    });
    const menu = document.querySelector('.list-menu--mega');
    let setNextTabTarget = null;

    // Utility function to get next focusable element
    const getNextFocusable = (el) => {
      if (!el) return null;
      return el.querySelector('[tabindex]:not([tabindex="-1"]), a');
    };

    // Handle submenu links in multi-level result columns
    document
      .querySelectorAll('.multi-level-menu__column--result .multi-level-menu__wrapper li:last-child a')
      .forEach((link) => {
        link.addEventListener('mouseover', (e) => console.log(e.target));

        link.addEventListener('focusin', () => {
          const parentMenu = link.closest('[data-associated-menu]');
          const currentActiveMenu = document.querySelector('.js-menu-click.is-active');
          if (!parentMenu || !currentActiveMenu) return;

          const parentLi = currentActiveMenu.closest('li');
          const nextLi = parentLi?.nextElementSibling;
          if (nextLi) setNextTabTarget = nextLi.querySelector('a');
        });
        // Set Next Tab target to null when focus leaves the link
        link.addEventListener('focusout', () => {
          setNextTabTarget = null;
        });
      });

    // Handle submenu links in input columns
    document.querySelectorAll('.multi-level-menu__column--input li:last-child a').forEach((link) => {
      const parentLi = link.closest('.header__menu-li-js');
      if (!parentLi) return;

      link.addEventListener('focusin', () => {
        const nextLi = parentLi.nextElementSibling;
        const nextFocusable = getNextFocusable(nextLi);
        setNextTabTarget = nextFocusable || document.querySelector('.header__heading-link');
      });
      // Set Next Tab target to null when focus leaves the link
      link.addEventListener('focusout', () => {
        setNextTabTarget = null;
      });
    });

    // Handle Tab key to move focus
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Tab' && setNextTabTarget && !e.shiftKey) {
        e.preventDefault();
        setNextTabTarget.focus();
        setNextTabTarget = null;
      }
    });
  });

  } catch(e) { console.error(e); }
})();
})();
